import React__default from 'react';
import classnames from 'classnames';
import { Icon } from '@grandvisionhq/icons';

const icons = {
    astigmatism: 'astigmatism',
    bestSeller: 'shopping-basket-star',
    blueLightFilter: 'blue-light-filter',
    sustainable: 'sustainable',
    forBaby: 'for-baby',
    forDryEyes: 'for-dry-eyes',
    forKids: 'for-kids',
    includingGlasses: 'frame',
    lastChance: 'last-chance',
    mirroredGlasses: 'glasses-futuristic',
    multifocal: 'store-eye-test',
    newCollection: 'new-collection',
    onlineOnly: 'happy-computer',
    polarisedGlasses: 'polarised-glasses',
    prescription: 'store-eye-test',
    seenOnTv: 'seen-on-tv',
    staffPick: 'shop-assistant',
    storeOnly: 'store',
    threeDPrinted: 'three-d-printed',
    trendy: 'trendy',
    twoMonthsForFree: 'shipment-next',
    uvProtection: 'polarised-glasses',
    smartGlasses: 'smart-glasses'
};
const Tag = ({ className , iconKey , label  })=>{
    const iconName = iconKey ? icons[iconKey] : null;
    return /*#__PURE__*/ React__default.createElement("div", {
        className: classnames('block-tag', {
            'block-tag--with-icon': !!iconName
        }, className)
    }, iconName && /*#__PURE__*/ React__default.createElement("div", {
        className: "block-tag__icon"
    }, /*#__PURE__*/ React__default.createElement(Icon, {
        name: iconName,
        height: 14,
        width: 14
    })), /*#__PURE__*/ React__default.createElement("div", {
        className: "block-tag__label"
    }, label));
};
var Tag$1 = Tag;

export { Tag$1 as default };
//# sourceMappingURL=Tag.js.map
